import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Divider,
  CardActions,
  Button,
} from '@material-ui/core';

import Icon from 'components/Icon';
import useStyles from '../styles/ListCard';

export interface Item {
  leftIcon: React.ReactNode;
  actionIcon?: React.ReactNode;
  actionText?: string;
  onActionClick?: () => void;
  primaryText: string;
  secondaryText: string;
}

interface Props {
  title?: string;
  actions?: React.ReactNode;
  listItems?: Item[];
  reverseLabels?: boolean;
  noCardPadding?: boolean;
}

const ListCard: React.SFC<Props> = (props) => {
  const { title, listItems, actions, reverseLabels, noCardPadding } = props;
  const classes = useStyles({ hasActions: !!actions, noCardPadding });

  if (!listItems) return <></>;

  const canShowBorder = (idx: number) =>
    (listItems.length > 1 && !actions) || idx !== listItems.length - 1;

  return (
    <Card>
      {title && <CardHeader title={title} />}
      <CardContent className={classes.cardContent}>
        <List>
          {listItems.map((item: Item, idx: number) => (
            <div key={idx}>
              <ListItem className={classes.listItem}>
                <ListItemIcon>
                  <Icon alignLeft>{item.leftIcon}</Icon>
                </ListItemIcon>
                <div className={classes.listItemTextContainer}>
                  {reverseLabels && (
                    <ListItemText className={classes.listItemText} secondary={item.secondaryText} />
                  )}
                  <ListItemText className={classes.listItemText} primary={item.primaryText} />
                  {!reverseLabels && (
                    <ListItemText className={classes.listItemText} secondary={item.secondaryText} />
                  )}
                </div>
                <ListItemSecondaryAction>
                  {item.actionIcon && (
                    <IconButton
                      edge="end"
                      onClick={() => item.onActionClick && item.onActionClick()}
                    >
                      {item.actionIcon}
                    </IconButton>
                  )}
                  {item.actionText && (
                    <Button
                      color="primary"
                      onClick={() => item.onActionClick && item.onActionClick()}
                    >
                      {item.actionText}
                    </Button>
                  )}
                </ListItemSecondaryAction>
              </ListItem>
              {canShowBorder(idx) && <Divider variant="inset" component="li" />}
            </div>
          ))}
        </List>
      </CardContent>
      {actions && (
        <>
          <Divider />
          <CardActions style={{ justifyContent: 'flex-end' }}>{actions}</CardActions>
        </>
      )}
    </Card>
  );
};

export default ListCard;
